import React from "react";
import PropTypes from "prop-types";

export default function ConcentratorIcon({ fill, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 8.467 8.467"
    >
      <path
        d="M11.525 3.588a3.843 3.843 0 0 0-3.851 3.851v1.416c-.002.031-.01.06-.01.092v17.088c0 .814.657 1.469 1.47 1.469h14.089c.813 0 1.468-.655 1.468-1.469V8.947c0-.027-.006-.053-.007-.08V7.44a3.843 3.843 0 0 0-3.852-3.851z"
        style={{
          fill: "none",
          stroke:"#3b3b3bff",
          strokeWidth: 1.97294,
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          paintOrder: "markers fill stroke",
          strokeOpacity: 1,
        }}
        transform="scale(.26458)"
      />
      <rect
        width={0.496}
        height={0.839}
        x={2.575}
        y={7.211}
        ry={0.248}
        style={{
          fill: {fill},
          stroke: "none",
          strokeWidth: 0.264583,
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          paintOrder: "markers fill stroke",
          fillOpacity: 1,
        }}
      />
      <rect
        width={0.496}
        height={0.839}
        x={5.54}
        y={7.211}
        ry={0.248}
        style={{
          fill: {fill},
          stroke: "none",
          strokeWidth: 0.264583,
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          paintOrder: "markers fill stroke",
          fillOpacity: 1,
        }}
      />
      <rect
        width={2.466}
        height={0.067}
        x={3.018}
        y={1.803}
        ry={0.033}
        style={{
          fill: "none",
          stroke:"#3b3b3bff",
          strokeWidth: 0.470661,
          strokeLinejoin: "round",
          strokeMiterlimit: 4,
          strokeDasharray: "none",
          paintOrder: "markers fill stroke",
          strokeOpacity: 1,
        }}
      />
    </svg>
  );
}

ConcentratorIcon.defaultProps = {
  size: "14",
  fill: "#4b4b4b",
};

ConcentratorIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
};
